import React, { Component } from 'react'
import { get, has } from "lodash"
import { Input } from 'antd';
import { debounce } from 'throttle-debounce';

import variables from "./../../../assets/styles/values.scss"
import styles from "./inputWrapper.module.scss"

class InputWrapper extends Component {
  constructor(props) {
    super(props);

    this.handleChangeDebounce = debounce(variables.delayInputTrigger, !!this.props.onChange ? this.props.onChange.bind(this) : () => { })
  }

  componentDidMount() {
    const { name, onChange, keyName, focus } = this.props
    let tag = document.getElementById(name)

    tag.setAttribute("spellcheck", "false")

    if (!has(this.props, "valueStore") && onChange)
      onChange(name, keyName, get(this.props, "defaultValue", ""))

    if (focus)
      document.getElementById(name).focus()
  }

  handleChange(e) {
    const { name, keyName, valueStore } = this.props

    if (has(e, ["target", "value"]))
      if (e.target.value.length !== valueStore)
        this.handleChangeDebounce(name, keyName, e.target.value)
  }

  handleBlur(e) {
    const { name, keyName } = this.props

    if (e.target.value !== get(this.props, "valueStore") && has(this.props, "valueStore"))
      this.handleChangeDebounce(name, keyName, e.target.value)
  }

  render() {
    const { name } = this.props

    return (
      <div className={styles.inputWrapper}>
        <Input
          className={styles.input}
          id={name}
          placeholder={get(this.props, "placeholder", "")}
          onChange={this.handleChange.bind(this)}
          onBlur={this.handleBlur.bind(this)}
          defaultValue={get(this.props, "valueStore", "")}
          disabled={get(this.props, ["disabled"], false)}
        />
      </div>
    )
  }
}

export default React.memo(InputWrapper)